var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorbell01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.05,12.19H5.68V3.82h8.37V12.19z M6.18,11.69h7.37V4.32H6.18V11.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.95,
    y: 4.06,
    className: "st2",
    width: 0.5,
    height: 7.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.14,8.41L9.5,8.5C9.43,8.8,9.29,9.03,9.09,9.18c-0.2,0.16-0.44,0.24-0.72,0.24c-0.3,0-0.54-0.06-0.72-0.18 C7.46,9.12,7.32,8.94,7.22,8.71c-0.1-0.23-0.14-0.47-0.14-0.73c0-0.29,0.05-0.54,0.16-0.75c0.11-0.21,0.27-0.37,0.47-0.48 c0.2-0.11,0.42-0.16,0.66-0.16c0.28,0,0.51,0.07,0.69,0.21c0.19,0.14,0.32,0.34,0.39,0.59L9.1,7.46 c-0.06-0.2-0.15-0.35-0.28-0.44C8.7,6.94,8.55,6.89,8.37,6.89c-0.21,0-0.39,0.05-0.53,0.15C7.7,7.15,7.6,7.28,7.54,7.45 C7.48,7.62,7.45,7.8,7.45,7.98c0,0.23,0.03,0.44,0.1,0.61c0.07,0.17,0.17,0.3,0.32,0.39c0.14,0.09,0.3,0.13,0.47,0.13 c0.2,0,0.37-0.06,0.52-0.18C9,8.81,9.09,8.64,9.14,8.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.5,9.37V6.63h0.36v1.13h1.43V6.63h0.36v2.74h-0.36V8.08h-1.43v1.29H10.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 7.75,
    className: "st2",
    width: 3.76,
    height: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbell01);
export default __webpack_public_path__ + "static/media/Doorbell-01.114631ab4ff926b4e8a45bf6229d8bc7.svg";
export { ForwardRef as ReactComponent };